<template>
  <layout-vertical :nav-menu-items="items_menu">
    <router-view />

  </layout-vertical>
</template>

<script setup>

import LayoutVertical from '@layouts/layout-vertical/LayoutVertical.vue'

import navMenuItems from '@/navigation/vertical'
import navMenuItemsCliente from '@/navigation/vertical/cliente';
import navMenuItemsAutorPorEncargo from '@/navigation/vertical/autorPorEncargo';
import navMenuItemsPromotor from '@/navigation/vertical/promotor';
import useUsuarioStore from '@/store/usuario';

const showCustomizer = true;

const usuario_store = useUsuarioStore();
const { isRol } = storeToRefs(usuario_store);

const items_menu = computed(() => {
  if (isRol.value('Autor')) {
    return navMenuItemsCliente;
  } else if (isRol.value(['Promotor', 'Promotora', 'Partner'])) {
    return navMenuItemsPromotor;
  } else if (isRol.value('Autor por encargo')) {
    return navMenuItemsAutorPorEncargo;
  } else {
    return navMenuItems;
  }

});

</script>